







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'ErrorField',
})
export default class ErrorField extends Vue {
    @Prop({ type: String, default: '' }) readonly error!: string
}
